import React, { memo } from 'react'

import { Icon, ImageAI } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { number } from 'prop-types'

import { iconSizeXLarge } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

const loadingIcon = <Icon svgComponent={ImageAI} size={iconSizeXLarge} color="dark" notSpaced />

// Loading turn: "Creating your image..." label above a shimmering placeholder. A run with
// several variations gets one placeholder per image, laid out like the grid they turn into.
function GeneratingState({ count = 1 }) {
  const t = useTranslation()
  const isMultiple = count > 1

  return (
    <div className="image-assistant-create-tab__generating">
      <p className="image-assistant-create-tab__generating-label cgt-body-base">
        {t(isMultiple
          ? 'imageAssistantPanel.createTab.generatingState.labelMultiple'
          : 'imageAssistantPanel.createTab.generatingState.label')}
      </p>
      {isMultiple ? (
        <div className="image-assistant-create-tab__generating-grid">
          {Array.from({ length: count }, (_, index) => (
            <div
              key={index}
              className="image-assistant-create-tab__loading-card image-assistant-create-tab__loading-card--grid"
            >
              {loadingIcon}
            </div>
          ))}
        </div>
      ) : (
        <div className="image-assistant-create-tab__loading-card">{loadingIcon}</div>
      )}
    </div>
  )
}

GeneratingState.propTypes = {
  count: number,
}

export default memo(GeneratingState)
